import React, { Fragment, useMemo } from 'react';
import {
    Button,
} from 'reactstrap';
import { FaExternalLinkAlt } from "react-icons/fa";

const ViewLogs = ({ row, onOpenLogs, renderTrigger }) => {

    const viewTriggerNode = useMemo(() => {
        if (typeof renderTrigger === "function") {
            return renderTrigger({ onClick: () => onOpenLogs(row) });
        }

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ paddingLeft: '10px' }}>
            <Button
                color="primary"
                size="xs"
                onClick={() => onOpenLogs(row)}
            >
                <FaExternalLinkAlt />                
            </Button>
            </div>
        );
    }, [renderTrigger, row, onOpenLogs]);

    return <>{viewTriggerNode}</>;
};

export default ViewLogs;
